<div
  [ngClass]="{ 'centered-with-image': content.image }"
  class="modal-container p-6"
>
  <div class="modal-top">
    <div *ngIf="content.image">&nbsp;</div>
    <h2 mat-dialog-title>
      <img
        *ngIf="content.image"
        [src]="content.image"
        alt="modal image"
      >
      {{ content.title }}
    </h2>
    <div class="close-btn">
      <app-ui-icon (click)="closeDialog()" color="var(--blue-3)" name="close" size="md"></app-ui-icon>
    </div>
  </div>

  <div mat-dialog-content>
    <div [innerHTML]="content.message"></div>
  </div>

  <div class="modal-actions" mat-dialog-actions>
    <app-ui-button
      (onClick)="closeDialog()"
      [color]="'ghost'"
      [compressed]="false"
      [expanded]="'block'"
      [size]="'lg'"
    >
      Stäng
    </app-ui-button>
  </div>
</div>
